import type { ProductService } from '@/types/order.types';

/**
 * Is this catalog service active (DV-3586)? Only `true` counts: products-api's
 * `active` is a nullable `Boolean`, and its own check (`ActiveTrue`) treats
 * null as inactive. Every reader of `ProductService.active` goes through here,
 * so a bare `s.active` or `s.active !== false` cannot let a null through.
 */
export const isActiveService = (
  service: Pick<ProductService, 'active'>
): boolean => service.active === true;
